export const FETCH_MULTI_DELETE_TASK_REQUEST = 'FETCH_MULTI_DELETE_TASK_REQUEST'
export const FETCH_MULTI_DELETE_TASK_SUCCESS = 'FETCH_MULTI_DELETE_TASK_SUCCESS'
export const FETCH_MULTI_DELETE_TASK_MINUS_ONE_SUCCESS = 'FETCH_MULTI_DELETE_TASK_MINUS_ONE_SUCCESS'
export const FETCH_MULTI_DELETE_TASK_FALUIRE = 'FETCH_MULTI_DELETE_TASK_FALUIRE'
